import axios from 'axios';
import BusinessUnit from '@/domain/businessUnit/businessUnit.entity';
import CostCenter from '@/domain/costCenter/costCenter.entity';
import snackBarService from '@/shared/snackbar/snackbar.service';

export default class BusinessUnitService {
  static searchAllBusinessUnit(): Promise<BusinessUnit[]> {
    return axios
      .get('/project-api/business-units')
      .then((response: any) => BusinessUnit.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static searchAllCostCenterByBusinessUnit(idBusinessUnit: string): Promise<CostCenter[]> {
    return axios
      .get(`/project-api/business-unit/${idBusinessUnit}/result-centers`)
      .then((response: any) => CostCenter.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
